<template>
    <div>
        <card-seplag titulo="Auditoria">
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <label style='color: red;'><span>*</span> Campos obrigatórios</label>
                </div>
                <Panel header="Filtros" class="p-col-12">
                    <div class="p-grid p-fluid">
                        <Rotulo nome="Matrícula" cols="12 2 " :requerido="true">
                            <span class="p-input-icon-right">
                                <i class="pi pi-search" />
                                <InputText placeholder="Matricula" type="text" v-model="matriculaSelecionada" />
                            </span>
                        </Rotulo>
                        <Rotulo nome="CPF" cols="12 4 2">
                            <span class="p-input-icon-right">
                                <i class="pi pi-search" />
                                <InputText placeholder="CPF" type="text" v-model="cpfSelecionado" />
                            </span>
                        </Rotulo>
                        <Rotulo nome="Usuário" cols="12 4 4">
                            <span class="p-input-icon-right">
                                <i class="pi pi-search" />
                                <InputText placeholder="Usuário" type="text" v-model="usuarioSelecionado" />
                            </span>
                        </Rotulo>
                        <Rotulo nome="Transação" cols="12 4 2" :requerido="true">
                            <Dropdown class="classe-dropdown" v-model="transacaoSelecionada"
                                :options="dropdownTransacoes" placeholder="Selecione uma operação" :filter="true" />
                        </Rotulo>
                        <Rotulo nome="Data inicial" cols="12 4 2">
                            <InputText type="datetime-local" v-model="dataInic" placeholder="dd/mm/aaaa" />
                        </Rotulo>
                        <Rotulo nome="Data final" cols="12 4 2">
                            <InputText type="datetime-local" v-model="dataFinal" placeholder="dd/mm/aaaa" />
                        </Rotulo>
                        <Rotulo nome="Operação" cols="12 4 2" :requerido="true">
                            <MultiSelect class="classe-dropdown" v-model="operacaoSelecionada"
                                :options="operacoesSelecionar" placeholder="Selecione uma operação" display="chip"
                                optionLabel="name" optionValue="value" />
                        </Rotulo>
                        <Rotulo cols="12 4 4" />
                        <Rotulo cols="12 4 4" class="botao">
                            <Button label="Pesquisar" @click="auditoriaBusca()" />
                        </Rotulo>
                    </div>
                </Panel>
                <Panel header="Auditoria" class="p-col-12">
                    <div class="p-grid p-fluid">
                        <Rotulo nome="Matrícula" cols="12 4 2">
                            <span class="p-input-icon-right">
                                <InputText placeholder="Matricula" type="text" v-model="campoAuditoria.matricula"
                                    :disabled="true" />
                            </span>
                        </Rotulo>
                        <Rotulo nome="Vínculo" cols="12 4 2">
                            <span class="p-input-icon-right">
                                <InputText placeholder="Vinculo" type="text" v-model="campoAuditoria.vinculo"
                                    :disabled="true" />
                            </span>
                        </Rotulo>
                        <Rotulo nome="CPF" cols="12 4 2">
                            <span class="p-input-icon-right">
                                <InputText placeholder="CPF" type="text" v-model="campoAuditoria.cpf"
                                    :disabled="true" />
                            </span>
                        </Rotulo>
                        <Rotulo nome="Usuário" cols="12 4 4">
                            <span class="p-input-icon-right">
                                <InputText placeholder="Usuário" type="text" v-model="campoAuditoria.usuario"
                                    :disabled="true" />
                            </span>
                        </Rotulo>
                        <Rotulo nome="Data/Hora " cols="12 4 2">
                            <InputMask id="date" mask="99/99/9999 99:99:99" v-model="campoAuditoria.data"
                                placeholder="Data auditável" slotChar="dd/mm/yyyy hh:MM:ss" :disabled="true" />
                        </Rotulo>
                        <Rotulo nome="Operação" cols="12 4 2">
                            <InputText v-model="campoAuditoria.operacao" :disabled="true"
                                placeholder="Operação selecionada" />
                        </Rotulo>
                        <Rotulo nome="Transação/Tela" cols="12 4 2">
                            <span class="p-input-icon-right">
                                <InputText placeholder="Transação/Tela" v-model="campoAuditoria.transacao"
                                    :disabled="true" />
                            </span>
                        </Rotulo>
                        <Rotulo nome="Estação" cols="12 4 2">
                            <span class="p-input-icon-right">
                                <InputText placeholder="Estação" v-model="campoAuditoria.estacao" :disabled="true" />
                            </span>
                        </Rotulo>
                    </div>
                </Panel>
                <div class="p-col-12 campoBotao">
                    <div class="p-grid p-fluid">
                        <Rotulo cols="12 8" />
                        <Rotulo cols="12 2" class="botao ">
                            <Button label="Anterior" icon="pi pi-arrow-left" iconPos="left" v-on:click="tras"
                                :disabled="counter <= 0" @click="paginacao()" />
                        </Rotulo>
                        <Rotulo cols="12 2" class="botao ">
                            <Button label="Próximo" icon="pi pi-arrow-right" iconPos="right" v-on:click="frente"
                                :disabled="totalElements == 0 || counter == totalElements - 1 || totalElements == null || counter == null || audit.length <= 0"
                                @click="paginacao()" />
                        </Rotulo>
                    </div>
                </div>
                <Rotulo cols="8" />
                <Panel
                    :header=" totalElements== null || totalElements == 0 || totalElements == 1 ? 'Registros' :  contadorPaginas + ' de ' + totalElements + ' Registros' "
                    class="p-col-12">
                    <div class="p-col-12">
                        <table-seplag :dados.sync="auditoriaCampos" :campos="camposTableAudit"
                            :totalRegistro.sync="totalElements" :loading="loadingPaginacao" :exibirCabecalho="true"
                            :paginacao="true" :urlPaginacao="urlPaginacao" :linhas="20" cols="12">
                        </table-seplag>
                    </div>
                </Panel>

            </div>
        </card-seplag>


    </div>
</template>

<script >

import CardSeplag from '@/template/CardSeplag.vue';
import TableSeplag from '@/template/TableSeplag.vue';
import { baseApiUrl } from '@/config/global'
import Rotulo from "@/template/RotuloSeplag.vue";
import MultiSelect from 'primevue/multiselect';

export default {
    components: { CardSeplag, TableSeplag, Rotulo, MultiSelect },
    data: function () {
        return {
            dropdownOperacoes: null,
            operacoesSelecionar: [
                { name: "INSERÇÃO", value: "ADD" },
                { name: "ALTERAÇÃO", value: "MOD" },
                { name: "REMOÇÃO", value: "DEL" },
                // { name: "CONSULTA", code: "CON" },
            ],
            dropdownTransacoes: null,
            operacaoSelecionada: null,
            transacaoSelecionada: null,
            matriculaSelecionada: null,
            cpfSelecionado: null,
            usuarioSelecionado: null,
            matriculaAudit: null,
            vinculoAudit: null,
            cpfAudit: null,
            usuarioAudit: null,
            dataInic: null,
            dataFinal: null,
            estacaoSelecionada: null,
            dataInicioAudit: null,
            dataFinalAudit: null,
            operacaoAudit: null,
            transacaoAudit: null,
            auditoriaCampos: [],
            camposTableAudit: [
                { nome: 'campo', titulo: 'Campo', tamanho: '11.vw', alinhamento: "left" },
                { nome: 'antes', titulo: 'Antes', tamanho: '11.vw', alinhamento: "left" },
                { nome: 'depois', titulo: 'Depois', tamanho: '11.vw', alinhamento: "left" },
            ],
            loadingPaginacao: true,
            teste: null,
            totalElements: 0,
            audit: null,
            urlPaginacao: '',
            date: 'T00:00:00',
            date2: 'T00:00:00',
            dadosAudit: null,
            campoAuditoria: {
                matricula: null,
                vinculo: null,
                cpf: null,
                usuario: null,
                data: null,
                operacao: null,
                trasacao: null,
                estacao: null
            },
            counter: 0,
            contadorPaginas: 0
        }
    },
    methods: {
        input(event) {
            
        },
        carregarDados() {
            this.listarTransacoes();
        },
        listarTransacoes() {
            this.$http.get(`${baseApiUrl}/audit/recad/transacoesEtapas`).then(res => {
                this.dropdownTransacoes = res.data
            })
        },
        async auditoriaBusca() {
            this.auditoriaCampos = []
            this.totalElements = null
            let body = {
                matricula: parseInt(this.matriculaSelecionada),
                cpf: this.cpfSelecionado,
                usuario: this.usuarioSelecionado,
                dataInicio: this.dataInic,
                dataTermino: this.dataFinal,
                transacaoEtapaEnum: this.transacaoSelecionada,
                operacao: this.operacaoSelecionada,
                estacao: this.estacaoSelecionada4
            }

            this.audit = null
            this.dadosAudit = null
            this.totalElements = 0
            this.auditoriaCampos = []
            this.campoAuditoria.matricula = null
            this.campoAuditoria.vinculo = null
            this.campoAuditoria.cpf = null
            this.campoAuditoria.usuario = null
            this.campoAuditoria.data = null
            this.campoAuditoria.transacao = null
            this.campoAuditoria.operacao = null
            this.campoAuditoria.estacao = null
            this.counter = null
            this.contadorPaginas = null

            this.$http.put(`${baseApiUrl}/audit/recad?page=0`, JSON.stringify(body)).then(res => {
            this.audit = res.data
            this.dadosAudit = this.audit.page.content
            this.totalElements = res.data.page.totalElements
            this.auditoriaCampos = this.audit.listaTransacao
            this.totalElements = this.audit.page.totalElements
            this.campoAuditoria.matricula = this.audit.auditoria.matriculaServidorAuditado
            this.campoAuditoria.vinculo = this.audit.auditoria.vinculoServidorAuditado
            this.campoAuditoria.cpf = this.audit.auditoria.cpfServidorAuditado
            this.campoAuditoria.usuario = this.audit.auditoria.usuarioAuditoria
            this.campoAuditoria.data = this.audit.auditoria.dataEdicao
            this.campoAuditoria.transacao = this.audit.auditoria.transaçãoTabelaAuditada
            this.campoAuditoria.operacao = this.audit.auditoria.operacaoTabela
            this.campoAuditoria.estacao = this.audit.auditoria.estacaoEdicao
            this.counter = 0
            this.contadorPaginas = 1
          })

            // this.counter = 0
            // this.contadorPaginas = 1
        },
        async paginacao() {
            let body = {
                matricula: parseInt(this.matriculaSelecionada),
                cpf: this.cpfSelecionado,
                usuario: this.usuarioSelecionado,
                dataInicio: this.dataInic,
                dataTermino: this.dataFinal,
                transacaoEtapaEnum: this.transacaoSelecionada,
                operacao: this.operacaoSelecionada,
                estacao: this.estacaoSelecionada
            }
            let response = this.$http.put(`${baseApiUrl}/audit/recad?page=${this.counter}`, JSON.stringify(body))
            if (response.status != 200) {
                this.$http.put(`${baseApiUrl}/audit/recad?page=${this.counter}`, JSON.stringify(body)).then(res => {
                    this.audit = res.data
                    this.dadosAudit = this.audit.page.content
                    this.totalElements = res.data.page.totalElements
                    this.auditoriaCampos = this.audit.listaTransacao
                    this.totalElements = this.audit.page.totalElements
                    this.campoAuditoria.matricula = this.audit.auditoria.matriculaServidorAuditado
                    this.campoAuditoria.vinculo = this.audit.auditoria.vinculoServidorAuditado
                    this.campoAuditoria.cpf = this.audit.auditoria.cpfServidorAuditado
                    this.campoAuditoria.usuario = this.audit.page.content.dadoPessoal.nomePessoa
                    this.campoAuditoria.data = this.audit.auditoria.dataEdicao
                    this.campoAuditoria.transacao = this.audit.auditoria.transaçãoTabelaAuditada
                    this.campoAuditoria.operacao = this.audit.auditoria.operacaoTabela
                    this.campoAuditoria.estacao = this.audit.auditoria.estacaoEdicao
                })
            } else {
                this.audit = null
                this.dadosAudit = null
                this.totalElements = 0
                this.auditoriaCampos = []
                this.campoAuditoria.matricula = null
                this.campoAuditoria.vinculo = null
                this.campoAuditoria.cpf = null
                this.campoAuditoria.usuario = null
                this.campoAuditoria.data = null
                this.campoAuditoria.transacao = null
                this.campoAuditoria.operacao = null
                this.campoAuditoria.estacao = null
                this.counter = null
                this.contadorPaginas = null
            }


        },
        frente() {
            this.counter += 1
            this.contadorPaginas += 1
        },
        tras() {
            this.counter -= 1
            this.contadorPaginas -= 1
        }

    },
    mounted() {
        this.carregarDados()
    },

}
</script>
<style scoped>
.botao {
    margin-top: 20px;
}

.movimento {
    margin-left: 0px
}

.campoBotao {
    margin-top: -15px;
    margin-bottom: -25px;
    margin-left: -5px;
}
</style>